import { __assign } from "tslib";
// DS: C59M
/** A floating panel with links to share a deviation on social media */
import React, { useState } from 'react';
import copy from 'copy-to-clipboard';
import { useTranslation } from 'react-i18next';
import SocialShareButtons from '../../SocialShareButtons';
import LinkIcon from '@wix/da-ds/pkg/Icons/24x24/Link';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import BiButton from '@wix/da-bi/pkg/Components/BiButton';
import s from './MobileSharePopup.scss';
var MobileSharePopup = function (_a) {
    var url = _a.url, title = _a.title, biData = _a.biData;
    var t = useTranslation().t;
    var _b = useState(false), copied = _b[0], setCopied = _b[1];
    return (React.createElement("div", { className: s['root'] },
        React.createElement("div", { className: s['title'] }, t('share.via')),
        React.createElement(SocialShareButtons, { className: s['social-buttons'], buttonClassname: s['social-button'], shareButtonClassname: s['social-button-inner'], nameClassname: s['button-text'], url: url, title: title || url, buttons: ['facebook', 'twitter', 'tumblr', 'pinterest'], iconSize: 42, iconBgColor: "#0e0d20" // L8
            , logoFillColor: "#00e59b" // G3
            , biData: biData, showName: true }),
        React.createElement("div", { className: s['footer'] },
            React.createElement(BiButton, { biData: __assign({ evid: BiEventType.CLICK_COPY }, biData), className: s['copy-button'], onClick: function () {
                    copy(url);
                    setCopied(true);
                } },
                React.createElement(LinkIcon, { size: IconSize.BIG }),
                React.createElement("span", { className: s['button-text'] }, t(copied ? 'share.copied' : 'share.copyLink'))))));
};
MobileSharePopup.displayName = 'MobileSharePopup';
export default MobileSharePopup;
//# sourceMappingURL=MobileSharePopup.js.map